export default __webpack_public_path__ + "account-e2af96a6fc4b51230bedf5466e9ac7e1.svg";